module.exports = __webpack_public_path__ + "static/media/top-sport-video.177da9b0.mp4";